module.exports = __webpack_public_path__ + "static/media/hrbp_doc2.cc27ff06.jpg";